export class DirectionsInstance {
  private static Instance: google.maps.DirectionsService;
  public static getInstance(): google.maps.DirectionsService {
    if (!DirectionsInstance.Instance) {
      DirectionsInstance.Instance = new google.maps.DirectionsService();
    }
    return DirectionsInstance.Instance;
  }
}
